import React, { useState } from 'react';
import WithdrawForm from './WithDraw/WithDraw';
import ThayDoiBank from './ThayDoiBank/ThayDoiBank';
import ThayDoiPassBank from './ThayDoiPassBank/ThayDoiPassBank';
import LichSuNapRut from './LichSuNapRut/LichSuNapRut';
import LichSuNap from '../NapTien/LichSuNap/LichSuNap';

const RutTien = () => {
  const [activeTab, setActiveTab] = useState("ruttien");

  return (
    <>
      <div className="tabs-header">
        <div className="tabs">
          <button
            className={`tab ${activeTab === "ruttien" ? "active" : ""}`}
            onClick={() => setActiveTab("ruttien")}
          >
            ถอนเงิน
          </button>

          <button
            className={`tab ${activeTab === "hosoruttien" ? "active" : ""}`}
            onClick={() => setActiveTab("hosoruttien")}
          >
            ประวัติการถอนเงิน
          </button>

          <button
            className={`tab ${activeTab === "thaydoibank" ? "active" : ""}`}
            onClick={() => setActiveTab("thaydoibank")}
          >
            เปลี่ยนบัญชีธนาคาร
          </button>

          <button
            className={`tab ${activeTab === "thaydoipassruttien" ? "active" : ""}`}
            onClick={() => setActiveTab("thaydoipassruttien")}
          >
            เปลี่ยนรหัสผ่านถอนเงิน
          </button>
        </div>
      </div>

      <div className="tab-content">
        {activeTab === "ruttien" && <WithdrawForm />}
        {activeTab === "hosoruttien" && <LichSuNap />}
        {activeTab === "thaydoibank" && <ThayDoiBank />}
        {activeTab === "thaydoipassruttien" && <ThayDoiPassBank />}
      </div>
    </>
  );
};

export default RutTien;